import { httpManager as http } from '@/common/js/HttpManager';
import { formatToFormUrlencoded, getCookie, getFromClient, setToClient, clearClient } from '@/common/js/utils';
import { config } from 'CONFIG';
import { authSdk } from '@/api/authSdk';
import store from '@/store';

let prefix = process.env.OEM ? `${process.env.OEM}_` : '';
const ACCESS_TOKEN_KEY = `my_${prefix}cloud_access_token`;
const ACCESS_TOKEN_EXPIRES_KEY = `my_${prefix}cloud_token_expires`;
const CURRENT_ACCOUNT = `my_${prefix}cloud_current_account`;
const ISSUED_AT = `my_${prefix}issued_at`;
const REO_SESS_AUTH_CODE = 'REO_SESS_AUTH_CODE';
const REO_ONLINE_SIGN = 'REO_ONLINE_SIGN';

class User {

    constructor () {

        this.accessToken = getFromClient( ACCESS_TOKEN_KEY );
        this.tokenExpires = getFromClient( ACCESS_TOKEN_EXPIRES_KEY );

    }

    async goToAccountCenter ( requiresAuth ) {

        let accountCenterLoginUrl = config.accountCenterLoginUrl;
        let currentUrl = window.location.href;
        console.log( 'goToAccountCenter' );

        let setOnlineCookie = await authSdk.removeOnlineCookie();
        let setAuthCookie = await authSdk.removeAuthCookie();
        if ( setOnlineCookie && setAuthCookie && requiresAuth ) {

            console.error( 'go to login' );
            window.location.href = `${accountCenterLoginUrl}?redirect=${encodeURIComponent( currentUrl )}`;

        }

    }

    tokenValid () {

        let valid = this.accessToken && this.tokenExpires && ( new Date().getTime() < parseInt( this.tokenExpires ) + 60000 );
        console.log( 'token valid -> ' + valid );
        return Boolean( valid );

    }

    getToken () {

        return new Promise(( resolve, reject ) => {

            this.getTokenFromServer().then(({ accessToken, tokenExpires }) => {

                let expires = tokenExpires * 1000 + new Date().getTime();
                this.accessToken = accessToken;
                this.tokenExpires = expires;
                setToClient( ACCESS_TOKEN_KEY, accessToken, new Date( expires ));
                setToClient( ACCESS_TOKEN_EXPIRES_KEY, expires, new Date( expires ));
                console.log( 'set token suc' );
                resolve();

            }).catch( err => {

                console.error( `Failed to get token. ${err}` );
                // this.goToAccountCenter();
                reject( err );

            });

        });

    }

    getTokenFromServer () {

        return new Promise(( resolve, reject ) => {

            let body = {

                client_id: config.clientId,
                grant_type: 'session_implicit',
                code: getCookie( REO_SESS_AUTH_CODE )

            };

            http.httpRequest({

                method: `POST`,
                url: `/oauth2/token/`,
                data: formatToFormUrlencoded( body ),
                config: {

                    headers: {

                        'content-type': 'application/x-www-form-urlencoded'

                    },
                    withCredentials: true

                }

            }).then( res => {

                let data = res.data;
                let { access_token: accessToken, expires_in: tokenExpires } = data;
                console.log( 'get token from server' );
                resolve({

                    accessToken,
                    tokenExpires

                });

            }).catch( err => {

                reject( err );

            });

        });

    }

    accuontCenterIsLogined () {

        try {

            return getCookie( REO_ONLINE_SIGN ) !== null;

        } catch ( err ) {

            return false;

        }

    }

    async login ( requiresAuth ) {

        if ( !this.accuontCenterIsLogined()) {

            console.log( 'account not logined' );
            store.commit( 'LOGIN', { id: 0 });
            this.goToAccountCenter( requiresAuth );
            return false;

        }
        console.log( 'account logined' );
        try {

            await this.getSession();

        } catch ( err ) {

            if ( requiresAuth ) {

                store.commit( 'LOGIN_ERROR', true );

            } else {

                await authSdk.removeAuthCookie();
                await authSdk.removeOnlineCookie();
                this.clearToken();
                store.commit( 'LOGOUT' );

            }
            return false;

        }
        if ( this.tokenValid() && this.sessionValid()) {

            console.log( 'login with last session and token' );
            this.refreshHeader();
            return true;

        }
        console.log( 'session or token is not valid' );
        try {

            await this.getToken();
            this.refreshHeader();
            this.refreshSession();
            console.log( 'logined' );
            return true;

        } catch ( err ) {

            if ( requiresAuth ) {

                store.commit( 'LOGIN_ERROR', true );

            } else {

                await authSdk.removeAuthCookie();
                await authSdk.removeOnlineCookie();
                this.clearToken();
                store.commit( 'LOGOUT' );

            }
            console.error( err );
            return false;

        }

    }

    refreshSession () {

        console.log( 'refresh session' );
        let expires = 86400 * 1000 + new Date().getTime();
        setToClient( CURRENT_ACCOUNT, this.currentAccount, new Date( expires ));
        setToClient( ISSUED_AT, this.issuedAt, new Date( expires ));

    }

    refreshHeader () {

        console.log( 'refresh Authorization header' );
        http.setHeader( `Authorization`, `Bearer ${this.accessToken}` );

    }

    getUserInfo () {

        console.log( 'get info' );

        return new Promise(( resolve, reject ) => {

            http.get( `/users/@me/profile/` ).then( res => {

                let user = res.data;
                store.commit( 'LOGIN', user );
                console.log( 'get info suc' );
                resolve();

            }).catch( err => {

                store.commit( 'LOGIN_ERROR', true );
                console.log( 'get info err' );
                reject( err );

            });

        });

    }

    getSession () {

        return new Promise(( resolve, reject ) => {

            let sessionCode = getCookie( REO_SESS_AUTH_CODE );

            http.httpRequest({

                method: `GET`,
                url: `/oauth2/session/details/?session_code=${encodeURIComponent( sessionCode )}`,
                config: {

                    withCredentials: true

                }

            }).then( res => {

                let { account, issuedAt } = res.data;
                this.currentAccount = account;
                this.issuedAt = issuedAt;
                resolve();

            }).catch( err => {

                console.log( `session error ======> ${err}` );
                // this.goToAccountCenter();
                reject( err );

            });

        });

    }

    sessionValid () {

        let lastAccount = parseInt( getFromClient( CURRENT_ACCOUNT ));
        let lastIssued = parseInt( getFromClient( ISSUED_AT ));
        let currentAccount = parseInt( this.currentAccount );
        let issuedAt = parseInt( this.issuedAt );
        console.log( 'session valid -> ' + Boolean( lastAccount === currentAccount && lastIssued === issuedAt ));
        return lastAccount === currentAccount && lastIssued === issuedAt;

    }

    clearToken () {

        clearClient( ACCESS_TOKEN_KEY );
        clearClient( ACCESS_TOKEN_EXPIRES_KEY );
        clearClient( CURRENT_ACCOUNT );
        clearClient( ISSUED_AT );

    }

    setValue ( key, value ) {

        this[ key ] = value;

    }

}

export default new User();



// WEBPACK FOOTER //
// ./src/api/user.js